"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncStack = void 0;
const GlobalSymbol = Symbol("Global");
class AsyncStack {
    static getCurrent() {
        const current = this.current;
        return current;
    }
    static set(ctx) {
        this.current = ctx;
    }
    static fork() {
        const origin = AsyncStack.getCurrent();
        const fork = new AsyncStack(origin);
        fork.start();
        return fork;
    }
    constructor(origin) {
        // @ts-expect-error
        if (origin !== GlobalSymbol) {
            this.origin = origin;
        }
    }
    start() {
        AsyncStack.set(this);
    }
    // private yielded = false
    yield() {
        // if (!this.yielded) return;
        // this.yielded = true;
        AsyncStack.set(this.origin);
    }
}
exports.AsyncStack = AsyncStack;
// @ts-expect-error
AsyncStack.Global = new AsyncStack(GlobalSymbol);
AsyncStack.current = AsyncStack.Global;
AsyncStack.NO_DATA = Symbol("NO_DATA");
//# sourceMappingURL=AsyncStack.js.map